import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders,HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
import * as Access from '@app/models/access';
import { VersionFeedback, ShareVersionFeedback, FeedbackStatusCodeEnum } from '@core/models/version-feedback';
import { VersionShare, UploadVersionShare } from '@core/models/version-share.model';

@Injectable({
  providedIn: 'root'
})
export class VersionsRequests {
	private readonly prefix = "/versions";
    private readonly project_prefix = "/projects"; //for exceptional calls requiring the project id (reset/archive share)

    constructor(private http: HttpClient, private urlSrv : UrlService) {}

        
	public load$ = (id: number) : Observable<HttpResponse<Objects.Version>> =>
		this.http.get<Objects.Version>(
            this.urlSrv.build(this.prefix+"/"+id),
            { observe: 'response' }
        );

    // public loadHeader$ = (id: number) : Observable<Objects.Version> =>
	// 	this.http.get<Objects.Version>(this.urlSrv.build(this.prefix+"/"+id+"/headers"));

    public loadRelateds$ = (link: string) : Observable<Objects.Version[]> =>
        this.http.get<Objects.Version[]>(this.urlSrv.build(this.prefix),{params: new HttpParams().set('link', link)});

    public loadFiles$ = (id: number) : Observable<Objects.File[]> =>
        this.http.get<Objects.File[]>(this.urlSrv.build(this.prefix + "/" + id + "/files"), { params: new HttpParams().set('all', "true")});

    // public loadMessages$ = (id: number) =>
    //     this.http.get<Objects.Message[]>(this.urlSrv.build(this.prefix + "/" + id + "/messages"));

    // new request to get version messages with context (default or feedback)
    public loadComments$ = (id: number) =>
        this.http.get<Objects.VersionMessage[]>(this.urlSrv.build(this.prefix + "/" + id + "/comments"));
    
    public loadFeedbacks$ = (id: number) =>
        this.http.get<VersionFeedback[]>(this.urlSrv.build("/p/feedback/versions/feedbacks/"+id));

    public loadAccess$ = (id: number) =>
        this.http.get<Access.AccessVersion>(this.urlSrv.build(this.prefix + "/" + id + "/permissions"));
    
    public loadProject$ = (id: number) =>
        this.http.get<Objects.Request>(this.urlSrv.build(this.prefix + "/" + id + "/request"));
    
    public setStatus$ = (id: number, status: Objects.Status) => 
        this.http.put<Objects.Version>(this.urlSrv.build(this.prefix+"/"+id ), {status: status.id}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public setLabels$ = (id: number, labels: Array<Objects.Label>) => 
        this.http.put<Objects.Version>(this.urlSrv.build(this.prefix+"/"+id ), {labels: labels.map((l: Objects.Label) => l.id)}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public loadFeedbackFileNotes$ = (id:number,file:Objects.File) => 
        this.http.get<Objects.Note[]>(this.urlSrv.build("/p/feedback" + this.prefix + "/" + id + "/files/"+file.id+ "/notes"));

    // proposal on dec-2024 
    /**
     *  get notes counter for all shared version files
     *  `[GET] web/app/versions/{versionId}/annotations`
     * @param id version id
     * @returns all notes from `feedback` and `upload-vesions` in the shared file or 0 if none 
     */

    public loadFeedbackFileAnnotationsCounter$ = (id:number) => 
        this.http.get<Objects.AnnotationsCounter[]>(this.urlSrv.build(this.prefix + "/" + id + "/feedbacks/annotations"));

    public loadShareFeedback$ = (id:number,user:Objects.User) => 
        this.http.get<ShareVersionFeedback[]>(this.urlSrv.build("/p/feedback" + this.prefix + "/" + id + "/users/"+user.id));   
        
     // archive an user approval action for a version
     // TODO: put in shor way
    public archiveFeedback$ = (version:Objects.Version, feedback: VersionFeedback) => {
        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};

        let data: any = {status: FeedbackStatusCodeEnum.ARCHIVED_CODE}; // 0

        return this.http.put(
            this.urlSrv.build(this.prefix + "/" + version.id + "/feedbacks/users/"+feedback.user.id),
            data,
            options
        );
    }

    // new version shares from dec-2023
    public loadVersionShares$ = (vid:number) => 
        this.http.get<VersionShare[]>(this.urlSrv.build(this.prefix + "/" + vid + "/shares"));   

    public getAllUploadVersionShares$ = (hash: string): Observable<UploadVersionShare[]> => this.http.get<UploadVersionShare[]>("/web/share/upload-version/" + hash + "/versions");

    public archiveVersionShare$ = (version:Objects.Version, share: VersionShare, project: Objects.Request) => {
        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};
        
        let data: any = {status: FeedbackStatusCodeEnum.ARCHIVED_CODE}; // 0
        // [PUT] /web/app/projects/{id_project}/versions/{id_version}/shares/{entry_hash}
        return this.http.put(
            this.urlSrv.build(this.project_prefix+ "/" + project.id + this.prefix + "/" + version.id + "/shares/"+share.entry.token),
            data,
            options
        );
    }

    
    public resetVersionShare$ = (version:Objects.Version, share: VersionShare, project: Objects.Request) => {
        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};

        let data: any = {status: FeedbackStatusCodeEnum.OPENED_CODE }; // 1
        // [PUT] /web/app/projects/{id_project}/versions/{id_version}/shares/{entry_hash}
        return this.http.put(
            this.urlSrv.build(this.project_prefix+ "/" + project.id + this.prefix + "/" + version.id + "/shares/"+share.entry.token),
            data,
            options
        );
    }

    public submitNewVersionFiles$ = (token: string, filesList: Array<string>, version: Objects.Version) => this.http.post<any>("/web/share/upload-version/" + token + "/versions/"+version.id, {files: filesList});

    public submitNewVersionFeedback$ = (data: any): Observable<any> => {
        const url = this.urlSrv.build('/share'); 
        // Set your custom headers if needed
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          // Add more headers if necessary
        });
    
        return this.http.post(url, data);
    }
    

}